import 'angular-timer';

import { NgModule } from 'ng-metadata/core';
import { CheckoutTimerComponent } from './checkout-timer.component';

@NgModule({
  imports: [
    'timer',
  ],
  declarations: [
    CheckoutTimerComponent,
  ],
})
export class CheckoutTimerModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/checkout-timer/checkout-timer.module.ts